export default __webpack_public_path__ + "static/media/005.e8e8147f.png";